import React from 'react'
import { Checkbox } from 'semantic-ui-react'
import { connect } from 'react-redux'
import size from 'lodash/size'

import { Loan } from 'WebAPI'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import HistoryModal, { HistoryModalTrigger, HISTORY_MODAL } from 'shared/HistoryModal'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import LKGrid from '../../../../shared/LKGrid'
import { constants as DCConstants } from '../../../../DetailsContainer'
import config from './LKGridConfig'

import translate, { translateHistory } from '../../../translator'
import container from './container'
import { withGridApi } from 'src/features/shared/LKGrid/LKGridInstance/components/gridApi'
import RebuildSchedule from './RebuildSchedule'
import { REBUILD_SCHEDULE_MODAL } from '../constants'
import {
  RestrGraphicProps,
  RestrGraphicState,
  SheculeRestructureProps,
} from 'src/features/LoanDetails/types.LoanDetails'

const instanceName = `${DCConstants.DetailsGridPrefixes.loan}-RestrGraphic`

//@ts-ignore
@connect(null, {
  openModal: LKModalActions.open,
})
//@ts-ignore
@withGridApi(instanceName)
class RestrSchedule extends React.Component<RestrGraphicProps, RestrGraphicState> {
  constructor(props: RestrGraphicProps) {
    super(props)

    const { data, showCurrentGraphic } = props
    const lastRecord: any = data[data.length - 1] || {}

    this.state = {
      data,
      LoanEventID: lastRecord.LoanEventID,
      LoanEventHash: lastRecord.HashSum_LoanEventID_, // eslint-disable-line,
      showCurrentGraphic,
    }
  }

  getContextMenu = () => [
    {
      name: translateHistory('frm_auth_loanevent_history'),
      icon: 'footprint',
      action: () =>
        this.props.openHistoryModal({
          name: HISTORY_MODAL,
          ID: this.props.ID,
          hash: this.props.hash,
          page: 'eventhistory',
          additionalParams: {
            LoanEventID: this.state.LoanEventID,
            HashSum_LoanEventID_: this.state.LoanEventHash,
          },
        }),
    },
  ]

  selectLastRowFromDataForHistory = () => {
    const { gridApi } = this.props

    if (gridApi) {
      gridApi.api.forEachNode((node) => {
        if (node.rowIndex === this.state.data.length - 1) {
          node.setSelected(true, true)
        }
      })
    }
  }

  handleGridRowSelection = ({ node: { data, selected } }) => {
    if (selected) {
      this.props.getOldGraphicWithDate(data)

      const { LoanEventID, HashSum_LoanEventID_ } = data

      this.setState({
        LoanEventID,
        LoanEventHash: HashSum_LoanEventID_,
      })
    }
  }

  handleCheckboxChange = (_, { checked }: { checked: boolean }) => {
    this.setState({
      showCurrentGraphic: checked,
    })

    this.props.toggleShowOldGraphic(checked)
  }

  componentDidUpdate() {
    if (this.state.showCurrentGraphic) {
      this.selectLastRowFromDataForHistory()
    }
  }

  renderRestGraphic(unRestr: boolean) {
    const { showCurrentGraphic } = this.props
    const { data } = this.state

    if (unRestr) {
      return <p className="u-flex u-fluid u-justifyCenter u-alignCenter">{translate('pan_restr_schedules')}</p>
    }

    return (
      <div className="u-fluid u-relative">
        <LKGrid
          instanceName={instanceName}
          rowData={data}
          disabled={showCurrentGraphic}
          onRowSelected={this.handleGridRowSelection}
          {...config}
        />
      </div>
    )
  }

  setData = (newData: SheculeRestructureProps[]) => {
    this.setState({
      data: newData,
    })
  }

  render() {
    const { data, base, ID, hash } = this.props
    const { showCurrentGraphic } = this.state

    const unRestr = !size(data)

    return (
      <>
        {/*@ts-ignore*/}
        <RebuildSchedule ID={ID} hash={hash} setData={this.setData} />
        <HistoryModal APICall={Loan.details} noTrigger />
        <div className="u-flex u-directionColumn u-fluid">
          <div className="u-padding-5 u-flexCenter">
            <Checkbox
              className="u-marginBottom-5"
              disabled={unRestr}
              checked={showCurrentGraphic}
              label={translate('chk_current_schedule')}
              onChange={this.handleCheckboxChange}
            />
          </div>

          {this.renderRestGraphic(unRestr)}

          <div style={{ borderLeft: '1px solid lightgray', borderTop: '1px solid lightgray' }}>
            <div className="u-padding-5">
              {base.IsArrested !== 1 && [
                <LKButton alias="wizard" style={{ marginBottom: 3 }}>
                  {translate('cmd_restructure')}
                </LKButton>,
                <LKButton alias="undo">{translate('cmd_del_restruct')}</LKButton>,
              ]}
              <LKButton
                onClick={() => this.props.openModal({ name: REBUILD_SCHEDULE_MODAL })}
                style={{ marginBottom: 3 }}
              >
                {translate('cmd_rebuild_schedule')}
              </LKButton>
              <HistoryModalTrigger
                ID={ID}
                hash={hash}
                page="eventhistory"
                disabled={!this.state.LoanEventID}
                additionalParams={{
                  LoanEventID: this.state.LoanEventID,
                  HashSum_LoanEventID_: this.state.LoanEventHash,
                }}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default container(RestrSchedule)
